"use strict";

import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import gsap from 'gsap';

document.addEventListener('DOMContentLoaded', function () {
    const swiperLogoEl = document.querySelector('.swiper-logo .swiper');

    if (swiperLogoEl) {
        new Swiper(swiperLogoEl, {
            modules: [Autoplay],
            loop: true,
            loopAdditionalSlides: 11,
            slidesPerView: 'auto',
            spaceBetween: 112,
            speed: 6000,
            autoplay: {
                delay: 0,
                disableOnInteraction: true,
            },
            allowTouchMove: false,
        });
    }

    const filterOptionsEl = document.querySelector('.filter__options');

    if (filterOptionsEl) {
        const filterPillEl = filterOptionsEl.querySelector('.filter__pill');
        const filterOptionEls = filterOptionsEl.querySelectorAll('.filter__option');
        const projectCardEls = document.querySelectorAll('.card-project[data-categories]');
        let activeOptionEl = filterOptionsEl.querySelector('.filter__option.is-active') || filterOptionEls[0];

        function movePillTo(target) {
            filterOptionEls.forEach(function (option) {
                option.classList.toggle('is-highlighted', option === target);
            });
            gsap.to(filterPillEl, {
                x: target.offsetLeft,
                y: target.offsetTop,
                width: target.offsetWidth,
                duration: 0.35,
                ease: 'power3.out',
            });
        }

        function applyFilter(filterValue) {
            projectCardEls.forEach(function (card) {
                const categories = card.dataset.categories.split(' ');
                const matches = filterValue === 'all' || categories.indexOf(filterValue) !== -1;

                if (matches) {
                    if (getComputedStyle(card).display === 'none') {
                        gsap.set(card, { display: '', opacity: 0 });
                    }
                    gsap.to(card, { opacity: 1, duration: 0.3, ease: 'power2.out' });
                } else {
                    gsap.to(card, {
                        opacity: 0,
                        duration: 0.25,
                        ease: 'power2.in',
                        onComplete: function () {
                            gsap.set(card, { display: 'none' });
                        },
                    });
                }
            });
        }

        if (filterPillEl && activeOptionEl) {
            const syncPillToActive = function () {
                gsap.set(filterPillEl, {
                    x: activeOptionEl.offsetLeft,
                    y: activeOptionEl.offsetTop,
                    width: activeOptionEl.offsetWidth,
                });
            };

            // Position immediately (fallback fonts), then re-sync once the
            // real webfont has swapped in — its different character widths
            // would otherwise leave the pill measured against stale layout.
            syncPillToActive();
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(syncPillToActive);
            }

            filterOptionEls.forEach(function (option) {
                option.addEventListener('mouseenter', function () {
                    movePillTo(option);
                });

                option.addEventListener('click', function () {
                    if (option === activeOptionEl) return;
                    activeOptionEl.classList.remove('is-active');
                    option.classList.add('is-active');
                    activeOptionEl = option;
                    movePillTo(option);
                    applyFilter(option.dataset.filter);
                });
            });

            filterOptionsEl.addEventListener('mouseleave', function () {
                movePillTo(activeOptionEl);
            });
        }
    }

    document.querySelectorAll('.accordion__header').forEach(function (header) {
        header.addEventListener('click', function () {
            const expanded = header.getAttribute('aria-expanded') === 'true';
            header.setAttribute('aria-expanded', String(!expanded));
            header.nextElementSibling.hidden = expanded;
        });
    });

    const navbarEl = document.querySelector('.navbar');

    if (navbarEl) {
        let lastScrollY = window.scrollY;
        let navbarVisible = true;

        function showNavbar() {
            if (navbarVisible) return;
            navbarVisible = true;
            gsap.to(navbarEl, { yPercent: 0, duration: 0.4, ease: 'power2.out' });
        }

        function hideNavbar() {
            if (!navbarVisible) return;
            navbarVisible = false;
            gsap.to(navbarEl, { yPercent: -100, duration: 0.4, ease: 'power2.out' });
        }

        window.addEventListener('scroll', function () {
            const currentScrollY = window.scrollY;

            if (currentScrollY <= 50) {
                showNavbar();
            } else if (currentScrollY > lastScrollY) {
                hideNavbar();
            } else {
                showNavbar();
            }

            lastScrollY = currentScrollY;
        }, { passive: true });

        const navbarToggleEl = navbarEl.querySelector('.navbar__toggle');
        // .navbar__menu is a separate top-level overlay (not nested inside
        // .navbar), so it can have its own flat 8px viewport inset instead
        // of inheriting .navbar's container padding — queried from
        // document, not navbarEl.
        const navbarMenuEl = document.querySelector('.navbar__menu');
        const toggleBarTop = navbarEl.querySelector('.navbar__toggle-bar--top');
        const toggleBarBottom = navbarEl.querySelector('.navbar__toggle-bar--bottom');
        const menuLabels = navbarMenuEl ? navbarMenuEl.querySelectorAll('.navbar__menu-link-label') : [];
        const emailLabel = navbarMenuEl ? navbarMenuEl.querySelector('.navbar__menu-email-label') : null;

        if (navbarToggleEl && navbarMenuEl && toggleBarTop && toggleBarBottom) {
            let menuOpen = false;

            // One timeline drives the whole open/close interaction — reversed
            // on close by playing it backwards instead of building a second
            // set of animations:
            //  1. icon bars slide together, then rotate into an X
            //  2. the overlay grows from 0 height into the full 8px-inset sheet
            //  3. the menu labels slide down into view, staggered
            const menuTl = gsap.timeline({
                paused: true,
                defaults: { ease: 'power3.inOut' },
                onReverseComplete: () => gsap.set(navbarMenuEl, { display: 'none' }),
            });
            menuTl
                .set(navbarMenuEl, { display: 'flex' })
                .to(toggleBarBottom, { y: -4, duration: 0.2, ease: 'power4.inOut' })
                .to(toggleBarTop, { y: 4, duration: 0.2, ease: 'power4.inOut' }, '<')
                .to(toggleBarBottom, { rotation: 45, transformOrigin: '50% 50%', duration: 0.3, ease: 'power4.inOut' })
                .to(toggleBarTop, { rotation: -45, transformOrigin: '50% 50%', duration: 0.3, ease: 'power4.inOut' }, '<')
                .to(navbarMenuEl, {
                    height: 'calc(100% - 1rem)',
                    backgroundColor: '#c4c4c4',
                    duration: 0.6,
                }, '<')
                .to([...menuLabels, emailLabel], {
                    y: 0,
                    stagger: 0.08,
                    duration: 0.5,
                    ease: 'power3.out',
                }, '-=0.3');

            navbarToggleEl.addEventListener('click', function () {
                menuOpen = !menuOpen;
                navbarToggleEl.setAttribute('aria-expanded', String(menuOpen));
                document.body.style.overflow = menuOpen ? 'hidden' : '';

                if (menuOpen) {
                    menuTl.play();
                } else {
                    menuTl.reverse();
                }
            });
        }
    }
});
